/** @format */

import { Avatar, Box, ListItemAvatar, ListItemText, Stack, SvgIcon, Typography } from '@mui/material';
import Mail04Icon from '@untitled-ui/icons-react/build/esm/Mail04';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import TypographyTooltip from 'src/components/typography-tooltip';
import { setPushRejectToBookingRequest } from 'src/layouts/dashboard/booking-notice-button/booking-notice.slice';

const BookingRequestRetractNotice = ({ toastId, content }) => {
  const dispatch = useDispatch();

  const requestId = content.id;
  useEffect(() => {
    if (toastId) {
      dispatch(setPushRejectToBookingRequest(requestId));
    }
  }, [toastId, requestId]);

  return (
    <>
      <ListItemAvatar sx={{ mt: 0.5 }}>
        <Avatar>
          <SvgIcon sx={{ color: 'grey.700' }}>
            <Mail04Icon />
          </SvgIcon>
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexWrap: 'wrap',
              m: 0
            }}
          >
            <Stack direction="row" columnGap={0.5} width="100%">
              <Typography sx={{ mr: 0.5 }} variant="subtitle1">
                {content.tagKey}
              </Typography>
              <Typography variant="body2"> không còn tồn tại.</Typography>
            </Stack>

            <TypographyTooltip mixText={content.message} maxLines={5} variant="body2" />
          </Box>
        }
        primaryTypographyProps={{ component: 'div' }} // Chuyển thẻ <p> thành <div>
        secondaryTypographyProps={{ component: 'div' }}
        sx={{ my: 0 }}
      />
    </>
  );
};

export default BookingRequestRetractNotice;
